/**
 * sanitize user input
 */
export const sanitizeInput = (value: string): string => {
    return value
        .replace(/[^\w\s]/gi, '') // remove non-word characters (e. g.: ! % &) but keep spaces
        .replace(/\s{2,}/, ' ') // replace multiple spaces with a single space
        .trim() // trim result
    ;
};
